export const employeesColumns = [
  { title: "单据编号", key: "applyNumber", align: "center", minWidth: 150 },
  { title: "项目", key: "projectName", align: "center", minWidth: 150 },
  {
    title: "领款人",
    key: "receiveEmployeeName",
    align: "center",
    minWidth: 100
  },
  { title: "部门", key: "departmentName", align: "center", minWidth: 100 },
  { title: "金额", key: "money", align: "center", minWidth: 100 },
  {
    title: "开户行",
    key: "receiverBankName",
    align: "center",
    minWidth: 150
  },
  {
    title: "收款账号",
    key: "receiverBankNumber",
    align: "center",
    minWidth: 200
  },
  { title: "完成审批", key: "applyPassTime", align: "center", minWidth: 200 }
];

export const initEmployeeForm = {
  employeeName: "",
  employeeSex: "",
  employeePhoneNum: "",
  phoneNumIsSecret: false,
  employeeEmail: "",
  employeeNumber: "",
  rolesShow: "",
  roles: [],
  roleIds: {
    adds: [],
    deletes: []
  },
  entryTime: "",
  joinWorkTime: "",
  startOrganize: "",
  startRoles: [],
  post: "",
  idNumber: "",
  address: "",
  emergencyContact: "",
  emergencyPhoneNum: "",
  remark: "",
  type: "",
  sexEnumItemId: "",
  departments: [],
  departmentsAddAndDelete: {
    adds: [
      {
        departmentId: "",
        isDepartmentManager: false
      }
    ]
  },
  attendanceDepartmentId: ""
};

export const leaveStatus = {
  leaveTime: new Date(),
  isTransfer: true,
  transferId: "",
  leverId: ""
};

export const employeesActionConfig = [
  {
    actionName: "编辑",
    condition: (channel, enumCode) => !(channel === "invited" && enumCode === "unactivated"),
    functionName: "modifyEmployee"
  },
  {
    actionName: "同意",
    condition: (channel, enumCode) => channel === "invited" && enumCode === "unactivated",
    functionName: "agreeJoinEnterprise"
  },
  {
    actionName: "拒绝",
    condition: (channel, enumCode) => channel === "invited" && enumCode === "unactivated",
    functionName: "refuseJoinEnterprise"
  },
  {
    actionName: "移出团队",
    condition: (channel, enumCode) => enumCode === "leave",
    functionName: "outOfEnterprise"
  },
  {
    actionName: "办理离职",
    condition: (channel, enumCode) => enumCode === "transfer" || enumCode === "in-service",
    functionName: "leaveOffice"
  },
  {
    actionName: "删除",
    condition: (channel, enumCode) => channel === "addEmployee" && enumCode === "unactivated",
    functionName: "deleteUnactivatedEmployee"
  }
];

export const operationConfigs = {
  add: {
    type: "add",
    dialogTitle: "添加部门",
    saveButtonText: "添加",
    saveFunctionName: "addDepartment"
  },
  modify: {
    type: "modify",
    dialogTitle: "编辑部门",
    saveButtonText: "保存",
    saveFunctionName: "modifyDepartment"
  },

  delete: {
    type: "delete",
    dialogTitle: "删除部门",
    saveButtonText: "删除",
    saveFunctionName: "deleteDepartment"
  }
};

export const isRootDepartment = department => {
  return department.parentId === "0";
};
